import React from 'react';
import { Box } from '@mui/material';
import TeamRequestsHeader from 'team/components/adminRequests/TeamRequestsHeader';
import TeamRequestsList from 'team/components/adminRequests/TeamRequestsList';

const TeamAdminRequestsContainer = () => {
    return (
        <Box>
            <TeamRequestsHeader />
            <TeamRequestsList />
        </Box>
    );
};

export default TeamAdminRequestsContainer;
